import { render } from "./cookie-gdpr.component.vue?vue&type=template&id=57d8f8b4"
import script from "./cookie-gdpr.component.vue?vue&type=script&lang=js"
export * from "./cookie-gdpr.component.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programmazione\\Nodejs\\CallER\\webapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__